import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/motion/Reveal";
import ProductCard from "@/components/shop/ProductCard";

export default function FeaturedProducts({ products = [] }) {
  return (
    <section className="bg-white" aria-label="Featured research products">
      <div className="container-rnv py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <Reveal>
            <span className="overline">Selected materials</span>
            <h2 className="font-serif text-4xl md:text-5xl text-[#1E2A44] mt-3 leading-tight">
              Featured Research Products
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/shop" className="inline-flex items-center gap-2 text-sm text-[#1E2A44] link-underline font-medium" data-testid="featured-view-all">
              View all products <ArrowRight size={15} />
            </Link>
          </Reveal>
        </div>
        <StaggerGroup className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p) => (
            <StaggerItem key={p.slug}>
              <ProductCard product={p} />
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
